<template>
    <div class="shop-item">
        <!--todo 禮包增加樣式giftPack-->
        <div class="coupon-item" v-for="(item, index) in list.slice(0,PreviewNum)" :key="index" @click="onClick(item)"
            :class="{'giftPack': item.ticketTypeId === ticketTypeGiftPackId}">
            <div class="cover coupon-cover">
                <el-image
                        :src="item.titleImage"
                        fit="cover" lazy/>
            </div>
            <div class="title">
                <span class="coupon-type" :title="item.typeName">{{item.typeName.substring(0, 2)}}</span>
                {{item.name}}
            </div>
            <div class="brand">{{item.brandName}} {{item.storeName}}</div>
            <div class="left-count plus" v-if="item.residue >= 100 && (item.ticketTypeId === ticketTypeCouponId ||
              item.ticketTypeId === ticketTypeRewardPointId ||
              item.ticketTypeId === ticketTypeGiftPackId)">99</div>
            <div class="left-count" v-else-if="(item.ticketTypeId === ticketTypeCouponId ||
              item.ticketTypeId === ticketTypeRewardPointId ||
              item.ticketTypeId === ticketTypeGiftPackId)">{{item.residue}}</div>
            <div v-else></div>
        </div>
    </div>
</template>

<script>
    import * as constDefine from "@/store/constDefine";

    export default {
        name: "TicketItem",
        props: [
            'dataToken',
            'list',
            'PreviewNum' //預覽時抓取的筆數
        ],
        data() {
            return {
                ticketTypeCouponId: constDefine.TicketType.Coupon.id,
                ticketTypeLoyaltyCardId: constDefine.TicketType.LoyaltyCard.id,
                ticketTypeCardId: constDefine.TicketType.Card.id,
                ticketTypeRewardPointId: constDefine.TicketType.RewardPoint.id,
                ticketTypeGiftPackId: constDefine.TicketType.GiftPack.id,
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            onClick(item) {
                let objectType = 0
                let objectId = 0
                try {
                    let dataObject = this.$crypto.uriComponentToObject(this.dataToken);
                    objectType = dataObject.objectType || 0
                    objectId = dataObject.objectId || 0

                    if (objectType === constDefine.MerchantType.ShoppingArea) {
                        objectType = constDefine.MerchantType.ShoppingAreaActivity
                        objectId = item.shoppingAreaActivityId
                    }
                } catch(e) {
                    objectType = 0
                    objectId = 0
                }

                let obj = {
                    "id": item.id,
                    "ticketTypeId": item.ticketTypeId,
                    "objectType": objectType,
                    "objectId": objectId,
                }

                let encryptedString = this.$crypto.encryptObject(obj);
                this.$router.push({name: 'TicketDetail', query: {'p': encryptedString}});
            }
        }
    }
</script>
<style lang="less" scoped>

</style>